import dayjs from "dayjs"
import { useCallback } from "react"
import { useGraphContext } from "../GraphContext"

/*
 * returns a function that returns the xPosition of the specified "time"
 * relative to the left edge of the graph
 */
export function useGetTimeAsXPosition(): (time: string) => number {
  const {
    graphScrollDate,
    pointsPerHour,
    zoom,
  } = useGraphContext()

  return useCallback(
    (time: string) => {
      if (!time) {
        return NaN
      }

      const distanceFromCenter = dayjs(time)
        .diff(
          graphScrollDate,
          "hours",
          true,
        ) * pointsPerHour

      const distanceFromLeftEdge = distanceFromCenter + (zoom * pointsPerHour / 2)
      return distanceFromLeftEdge
    },
    [
      graphScrollDate,
      pointsPerHour,
      zoom,
    ],
  )
}
